import React, { useCallback, useState } from 'react'
import DataTableForCustomPaginationRoute from '../../../../components/DataTableForCustomPaginationRoute'
import {
  nameSource,
  ROUTE_PRIORITY_ENUM,
  ROUTE_PRIORITY_MAP,
  ROUTE_STATUS_ENUM,
  ROUTE_STATUS_MAP
} from '../domain/info'
import { headers } from '../domain/headers'
import { breadcrumbList } from '../domain/breadcrumb'
import { toolsList } from '../domain/tools'
import Container from '../../../../components/Container'
import { FaDownload } from 'react-icons/fa'
import api from '../../../../services/api'
import { Loading } from '../../../../components/Loading'
import { useToast } from '../../../../hooks/toast'
import moment from 'moment'

const RoutesList = (): JSX.Element => {
  const [isLoading, setIsLoading] = useState(false)
  const { addToast } = useToast()

  const handleGeneratePdf = useCallback(
    async (id: number) => {
      setIsLoading(true)
      try {
        const responsePdf = await api.get(
          `partnerships/routes/downloadRouteReport/${id}`,
          {
            responseType: 'arraybuffer'
          }
        )
        const blob = new Blob([responsePdf.data])
        const blobURL = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = blobURL
        a.download = `rota-${id}-${moment().format('DD-MM-YYYY-HH-mm-ss')}.pdf`
        document.body.appendChild(a)
        a.click()
      } catch (error) {
        console.log(error)
        addToast({
          title: 'Não foi possível gerar o PDF',
          description: 'Ocorreu um erro ao gerar o PDF'
        })
      } finally {
        setIsLoading(false)
      }
    },
    [addToast]
  )

  if (isLoading) {
    return <Loading isActive />
  }

  return (
    <Container
      pageTitle="Listagem"
      breadcrumb={breadcrumbList}
      tools={toolsList}
    >
      <DataTableForCustomPaginationRoute
        paginationUrl="partnerships/routes/pagination"
        source={nameSource}
        notHasChildren
        headers={headers}
        customHeaders={[
          {
            name: 'Status',
            field: 'status',
            sortable: true,
            element: item => (
              <span>{ROUTE_STATUS_MAP[item.status as ROUTE_STATUS_ENUM]}</span>
            )
          },
          {
            name: 'Prioridade',
            field: 'priority',
            sortable: true,
            element: item => (
              <span>
                {ROUTE_PRIORITY_MAP[item.priority as ROUTE_PRIORITY_ENUM]}
              </span>
            )
          },
          {
            name: 'Data',
            field: 'scheduled_date',
            sortable: true,
            element: item => (
              <span>
                {String(item.scheduled_date).split('-').reverse().join('/')}
              </span>
            )
          }
        ]}
        actions={[
          {
            name: 'view',
            title: 'Visualizar',
            linkTo: (item: any) => `/partnerships/routes/view/${item.id}`,
            htmlIcon: <span className="fa fa-search"></span>
          },
          {
            name: 'edit',
            title: 'Editar',
            linkTo: (item: any) => `/partnerships/routes/update/${item.id}`,
            htmlIcon: <span className="fa fa-edit"></span>
          },
          {
            name: 'download_report',
            title: 'Baixar Relatório',
            element: (item: any) => (
              <FaDownload
                size={16}
                onClick={() => handleGeneratePdf(item.id)}
              />
            )
          }
        ]}
      />
    </Container>
  )
}
export default RoutesList
